import Adjustments from '../module/adjustments/ptBR.locale';
import Brush from '../module/brush/ptBR.locale';
import CommonLocale from '../module/common/ptBR.locale';
import Crop from '../module/crop/ptBR.locale';
import Filters from '../module/filters/ptBR.locale';
import Stickers from '../module/stickers/ptBR.locale';
import Text from '../module/text/ptBR.locale';
export default {
    'pt-BR': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, CommonLocale), Adjustments), Crop), Filters), Text), Stickers), Brush),
};
